import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, Subscriber } from 'rxjs';
import { LoaderService } from 'src/app/services/loader.service';
import { AppConstants } from '../../app.constants';

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {
  private requests: HttpRequest<any>[] = [];

  constructor(private loaderService: LoaderService) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let skipLoader: boolean = req.headers.has('Skip-Loader');
    if (!skipLoader) {
      this.requests.push(req);
      this.loaderService.status$.next(true);
    }
    // We create a new observable which we return instead of the original
    return Observable.create((observer: Subscriber<HttpEvent<any>>) => {
      // And subscribe to the original observable to ensure the HttpRequest is made
      const subscription = next.handle(req)
        .subscribe(
          (event: HttpEvent<any>) => {
            if (event instanceof HttpResponse) {
              if (!skipLoader) {
                this.removeRequest(req);
              }
              observer.next(event);
            }
          },
          (err:any) => {
            if (!skipLoader) {
              this.removeRequest(req);
            }
            if (err instanceof HttpErrorResponse && err.status === 0
              && err.url.indexOf('/sessions/me') === -1) {
              AppConstants.showGlobalMsgDialog = true;
            }
            observer.error(err);
          },
          () => {
            if (!skipLoader) {
              this.removeRequest(req);
            }
            observer.complete();
          });
      // return teardown logic in case of cancelled requests
      return () => {
        this.removeRequest(req);
        subscription.unsubscribe();
      };
    });
  }

  removeRequest(req: HttpRequest<any>) {
    const i = this.requests.indexOf(req);
    if (i >= 0) {
      this.requests.splice(i, 1); // This removes the request from our array
    }
    // Let's tell our service of the updated status
    this.loaderService.status$.next(this.requests.length > 0);
  }
}
